import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"file-txt"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M20 10V7L15 2H4V22H20M14 2V8H20","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M8.5 13V19M8.5 13H7M8.5 13H10M15.5 13.0002L15.5 13.9087C15.5 13.9893 15.4735 14.0679 15.4242 14.1355C15.3941 14.1769 15.3581 14.2139 15.3272 14.2546L14 16.0002M12.5 13L12.5 13.9085C12.5 13.9892 12.5266 14.0677 12.5758 14.1353C12.6059 14.1767 12.6419 14.2137 12.6729 14.2545L14 16.0002M14 16.0002L12.6728 17.7456C12.6419 17.7863 12.6059 17.8233 12.5758 17.8646C12.5266 17.9323 12.5 18.0108 12.5 18.0915L12.5 19M14 16.0002L15.3272 17.7457C15.3581 17.7865 15.3941 17.8235 15.4242 17.8648C15.4734 17.9325 15.5 18.011 15.5 18.0917L15.5 19.0002M19.5 13.0001V19.0001M19.5 13.0001H18M19.5 13.0001H21","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const FileTxt = Vue.extend<IconProps>({
  name: 'FileTxtIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'file-txt',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default FileTxt;
